export default __webpack_public_path__ + "static/media/gears.295dc9f5.svg";